<button [type]="type" [disabled]="disabled || isClicking || (disabledByLoader && (loading$ | async))"  [ngClass]="_btnCls" class="vis-button-comp" [title]="title" (click)="onClick($event)">
    <mat-icon *ngIf="icon" [ngClass]="_iconCls" class="pref-icon vis-combine-icon">{{icon}}</mat-icon>
    <span [ngClass]="_spanCls" class="font-weight-bold" *ngIf="label">{{label}}</span>
</button>
